import { brands } from "../endpoints/brands.endpoints";
import $axios from "../http/accessor";

const BrandsService = {
  getAllBrands: (page: number, count: number, search?: string) => {
    return $axios.get(brands.get_all, {
      params: {
        page,
        count,
        search,
      },
    });
  },

  createBrand: (data: FormData) => {
    return $axios.post(brands.create, data);
  },

  getSingleBrand: (id: number) => {
    return $axios.get(brands.get_by_id(id));
  },

  deleteBrand: (id: number) => {
    return $axios.delete(brands.delete(id));
  },

  updateBrand: (id: number, data: FormData) => {
    return $axios.put(brands.edit(id), data);
  },
};

export default BrandsService;
